<div class="container-popover-recurso-premium">
  <h1>{{titulo}}</h1>
  <p>{{descricao}}{{sufixoDescricao}}</p>
  <cta-buttons>
    <button class="primary full" (click)="acaoPlanoUsuario()">
      <span>{{isTrialIniciado ? 'Conheça o Plano Premium' : 'Experimente por 7 Dias'}}</span>
      <ion-icon name="diamond"></ion-icon>
    </button>
  </cta-buttons>
</div>